module.exports = __webpack_public_path__ + "media/images/cat1-fb2c810df7fa298a48ef698f3da9c0e0.png";